// Namespaced help registries (CONTRACTS §6). Each lane owns the namespace file for the surfaces it builds and
// adds one line here; the coverage test (../helpCoverage.test.tsx) checks ids, placements and code references.
import type { HelpBody, HelpEntry, HelpSource } from '../types'
import { HELP as CAPABILITIES } from './capabilities'
import { HELP as CONNECT } from './connect'
import { HELP as CONSENT } from './consent' // FE:C1
import { HELP as PLAYBOOKS } from './playbooks'
import { HELP as REPORT_STUDIO } from './report-studio' // FE:C8
import { HELP as USERS } from './users' // S1
import { HELP as VIEWS } from './views' // FE:C7

export const HELP_NAMESPACES: Record<string, readonly HelpEntry[]> = {
  connect: CONNECT,
  consent: CONSENT, // FE:C1
  capabilities: CAPABILITIES,
  playbooks: PLAYBOOKS,
  'report-studio': REPORT_STUDIO, // FE:C8
  users: USERS, // S1
  views: VIEWS, // FE:C7
}

export const ALL_HELP: readonly HelpEntry[] = Object.values(HELP_NAMESPACES).flat()
export const HELP_BY_ID: Readonly<Record<string, HelpEntry>> = Object.fromEntries(ALL_HELP.map(entry => [entry.id, entry]))

export const toHelpBody = (entry: HelpEntry): HelpBody => ({ what: entry.body, how: entry.steps, limits: entry.limits })
const BODIES: Record<string, HelpBody> = Object.fromEntries(ALL_HELP.map(entry => [entry.id, toHelpBody(entry)]))

/** Registry entries are small and ship with the page, so they are always loaded. */
export const REGISTRY_SOURCE: HelpSource = {
  title: id => HELP_BY_ID[id]?.title,
  loaded: () => BODIES,
  load: async () => BODIES,
}
